module.exports = __webpack_public_path__ + "img/newyear.ad255c41.svg";